import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import * as Sentry from '@sentry/react';

const API_URL = import.meta.env.VITE_API_URL || 'https://api.do-more.site/graphql';
const REQUEST_TIMEOUT_MS = 30000;

const httpLink = createHttpLink({
  uri: API_URL,
  fetch: async (uri, options) => {
    const controller = new AbortController();
    const timeoutId = window.setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);

    try {
      return await fetch(uri, {
        ...options,
        signal: controller.signal,
      });
    } finally {
      window.clearTimeout(timeoutId);
    }
  },
});


const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('jwt');
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach((error) => {
      Sentry.captureException(new Error(`GraphQL fejl: ${error.message}`), {
        extra: {
          query: operation.operationName,
          path: error.path?.join('.'),
          extensions: error.extensions,
        },
      });
    });
  }
  if (networkError) {
    Sentry.captureException(networkError, {
      extra: { query: operation.operationName },
    });
  }
});

const client = new ApolloClient({
  link: errorLink.concat(authLink.concat(httpLink)),
  cache: new InMemoryCache(),
});

export default client;
